module.exports = __webpack_public_path__ + "static/img/zl.78c888d8.png";